//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import FooterTop from '~/components/footer/footerTop.vue'
import DescriptionBlock from '~/components/forCompanies/DescriptionBlock.vue'
import FeatureContainer from '~/components/forCompanies/FeatureContainer.vue'
import TitleBlock from '~/components/forCompanies/TitleBlock.vue'
import DescriptionCard from '~/components/forGaming/DescriptionCard.vue'
import TopScreen from '~/components/TopScreen.vue'
export default {
  components: {
    TitleBlock,
    TopScreen,
    DescriptionBlock,
    DescriptionCard,
    FooterTop,
    FeatureContainer
  },
  head () {
    return {
      title: this.$t('footer.industries.for-global-companies').concat(' | Pagsmile '),
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: this.$t('seo.description')
        }
      ]
    }
  }
}
